import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Waterfall1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WATERFALL1;
}

export default Waterfall1PoiTileEntity;
